"use strict";
// CRITICAL: This file is for BACKEND USE ONLY
// Never import or use in any frontend code
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectBeliefSystem = exports.determinePsychologicalApproach = exports.determineSensitivityLevel = exports.BELIEF_SYSTEM_PATTERNS = void 0;
// Belief system keywords and patterns (for detection only)
exports.BELIEF_SYSTEM_PATTERNS = {
    flat_earth: [
        'flat earth', 'globe lie', 'nasa fake', 'dome', 'firmament',
        'level plane', 'spinning ball', 'gravity hoax'
    ],
    vaccine_hesitancy: [
        'vaccine injury', 'vaccine death', 'big pharma', 'autism vaccine',
        'natural immunity', 'vaccine tracking', 'mrna dangerous'
    ],
    climate_skepticism: [
        'climate hoax', 'carbon dioxide plant food', 'solar cycles',
        'climate agenda', 'temperature manipulation', 'ice age coming'
    ],
    election_denial: [
        'stolen election', 'voting machines hacked', 'dead people voting',
        'ballot stuffing', 'election fraud', 'rigged election'
    ],
    conspiracy_general: [
        'deep state', 'cabal', 'illuminati', 'new world order',
        'false flag', 'crisis actors', 'controlled opposition'
    ],
    health_misinformation: [
        'cure cancer naturally', 'doctors hide cure', 'pharmaceutical conspiracy',
        'alternative medicine suppressed', 'medical establishment lie'
    ],
    financial_conspiracy: [
        'federal reserve scam', 'fiat currency collapse', 'gold standard',
        'bitcoin only hope', 'banks control everything', 'economic collapse'
    ]
};
// Sensitivity level determination
const determineSensitivityLevel = (beliefSystem, queryText) => {
    if (!beliefSystem || beliefSystem === 'none_detected')
        return 'low';
    // Check for emotional indicators
    const emotionalWords = ['lie', 'hoax', 'fake', 'truth', 'wake up', 'sheeple'];
    const hasEmotionalLanguage = emotionalWords.some(word => queryText.toLowerCase().includes(word));
    // Very high sensitivity topics
    if (['flat_earth', 'vaccine_hesitancy'].includes(beliefSystem)) {
        return hasEmotionalLanguage ? 'very_high' : 'high';
    }
    // High sensitivity topics
    if (['climate_skepticism', 'election_denial'].includes(beliefSystem)) {
        return hasEmotionalLanguage ? 'high' : 'medium';
    }
    // Medium sensitivity by default
    return hasEmotionalLanguage ? 'medium' : 'low';
};
exports.determineSensitivityLevel = determineSensitivityLevel;
// Determine best psychological approach
const determinePsychologicalApproach = (beliefSystem, sensitivityLevel) => {
    if (!beliefSystem || beliefSystem === 'none_detected') {
        return 'gradual_evidence';
    }
    // Match approach to belief system and sensitivity
    const approaches = {
        flat_earth: {
            low: 'curiosity_validation',
            medium: 'curiosity_validation',
            high: 'parental_empathy',
            very_high: 'personal_relevance'
        },
        vaccine_hesitancy: {
            low: 'authority_respect',
            medium: 'parental_empathy',
            high: 'parental_empathy',
            very_high: 'personal_relevance'
        },
        climate_skepticism: {
            low: 'economic_validation',
            medium: 'economic_validation',
            high: 'curiosity_validation',
            very_high: 'personal_relevance'
        },
        election_denial: {
            low: 'social_proof',
            medium: 'authority_respect',
            high: 'curiosity_validation',
            very_high: 'personal_relevance'
        },
        conspiracy_general: {
            low: 'curiosity_validation',
            medium: 'curiosity_validation',
            high: 'personal_relevance',
            very_high: 'community_integration'
        },
        health_misinformation: {
            low: 'authority_respect',
            medium: 'parental_empathy',
            high: 'personal_relevance',
            very_high: 'personal_relevance'
        },
        financial_conspiracy: {
            low: 'economic_validation',
            medium: 'economic_validation',
            high: 'curiosity_validation',
            very_high: 'personal_relevance'
        },
        none_detected: {
            low: 'gradual_evidence',
            medium: 'gradual_evidence',
            high: 'gradual_evidence',
            very_high: 'gradual_evidence'
        }
    };
    return approaches[beliefSystem][sensitivityLevel];
};
exports.determinePsychologicalApproach = determinePsychologicalApproach;
// NEVER expose this function to frontend
const detectBeliefSystem = (queryText) => {
    const normalizedQuery = queryText.toLowerCase();
    for (const [system, patterns] of Object.entries(exports.BELIEF_SYSTEM_PATTERNS)) {
        for (const pattern of patterns) {
            if (normalizedQuery.includes(pattern.toLowerCase())) {
                return system;
            }
        }
    }
    return 'none_detected';
};
exports.detectBeliefSystem = detectBeliefSystem;
//# sourceMappingURL=detection.js.map